const $ = require('jquery')
const win = require('Helpers/win')

module.exports = function overlay(params) {
  const el = document.createElement('div')
  let delay
  const $el = $(el)
  const init = function init() {
    el.shown = true
    el.className = 'simple-overlay'
    hide()

    document.body.appendChild(el)

    el.show = show
    el.hide = hide
    el.loader = loader
    el.$el = $el

    win.on('resize', () => {
      el.style.width = `${win.width}px`
      el.style.height = `${win.height}px`
    })

    if (params && params.css && params.length) {
      // is jQueryObject
      // put overlay below params jquery obj
      const zIndex = params.css('z-index') - 1
      if (zIndex > 0) {
        $el.css('z-index', zIndex)
      }
    }
  }
  const show = function show(zIndex) {
    el.style.opacity = '0'
    el.style.display = 'block'
    if (zIndex) {
      el.style.zIndex = zIndex
    }

    clearTimeout(delay)
    delay = setTimeout(() => {
      el.style.opacity = '1'
    }, 50)
    el.shown = true
  }

  const hide = function hide() {
    el.style.opacity = '0'
    clearTimeout(delay)
    delay = setTimeout(() => {
      el.style.display = 'none'
    }, 150)

    el.shown = false
  }
  const loader = function loader(isShown) {
    if (isShown) {
      $el.addLoader()
    } else {
      $el.removeLoader()
    }
  }

  init()

  return el
}
